module.exports = __webpack_public_path__ + "static/img/header.d90e186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tianlian/header.png
// module id = R7zz
// module chunks = 5